module.exports = __webpack_public_path__ + "sgby/img/apple-btn.9f60589.png";